import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import * as routePaths from '../consts/route/routePaths';
import ModalTypes from '../enums/app/modalTypes';
import routerService from '../services/routerService';
import {hideModalAction, showUWMUnavailabilityModalAction} from '../state/ducks/modal';
import {makeSelectGlobalModal} from '../state/selectors/modal';
import {dispatch} from '../state/store';

const SHOW_UWM_UNAVAILABILITY_ON_PAGES = [routePaths.TIPS_AND_TUTORIALS, routePaths.QUICK_START_GUIDE];
const UWM_UNAVAILABILITY_TIMEOUT_IN_SEC = 30 * 1000;

export const useUWMUnavailabilityHandler = ({isVisible, refreshAction, isError}) => {
    const location = routerService.getCurrent();
    const deviceInSblModal = useSelector(makeSelectGlobalModal(ModalTypes.DEVICE_IS_IN_SBL));

    const hideModal = (uwmTimer) => {
        if (uwmTimer) {
            clearTimeout(uwmTimer);
        }
        dispatch(hideModalAction(ModalTypes.UWM_UNAVAILABILITY));
    };

    useEffect(() => {
        const isPagePermitted = SHOW_UWM_UNAVAILABILITY_ON_PAGES.find((page) => location.includes(page));
        let uwmTimer;

        if (isError && !deviceInSblModal) {
            dispatch(showUWMUnavailabilityModalAction({refreshAction}));
            clearTimeout(uwmTimer);
            return;
        }

        if (isPagePermitted && isVisible && !deviceInSblModal) {
            uwmTimer = setTimeout(() => {
                dispatch(showUWMUnavailabilityModalAction({refreshAction}));
            }, UWM_UNAVAILABILITY_TIMEOUT_IN_SEC);
        } else {
            hideModal(uwmTimer);
        }

        return () => {
            hideModal(uwmTimer);
        };
    }, [location, isVisible, isError, deviceInSblModal]);
};
